export function isStandalone() {
  return window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;
}

export function registerToolsWorker() {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    navigator.serviceWorker.register('/tools-sw.js', { updateViaCache: 'none' }).catch(error => {
      console.warn('Tools offline notice could not be registered.', error);
    });
  }
}
